import { FC } from 'react';
import { useSharedState } from '../hooks/useSharedState';
import MonthPicker from './MonthPicker';
import styles from './PeriodPicker.module.css';
import { CustomDatePicker } from './CustomDatePicker';
import { DateUtil } from '../utils/DateUtil';
import TimePicker from './TimePicker';


interface PeriodPickerProps {
    readOnly?: boolean;
}

const PeriodPicker: FC<PeriodPickerProps> = ({readOnly = false}) => {

    const [period, setPeriod] = useSharedState('period', '');
    const [time, setTime] = useSharedState('time', '');

    return <div className={styles.periodPickerContainer}>
        {(!readOnly || DateUtil.isValidDateString(period)) && <CustomDatePicker selectedDate={DateUtil.isValidDateString(period) ? DateUtil.createLocalDateFromYMD(period) : null} onDateSelected={(date) => setPeriod(DateUtil.formatDateToLocalYMD(date??new Date()))}/>}
        {(!readOnly || period == "thisWeek") && <div className={[styles.dateItem, period == "thisWeek" ? styles.selected : ""].join(' ')} onClick={readOnly ? undefined : () => setPeriod("thisWeek")}>Cette semaine</div>}
        {(!readOnly || period == "nextWeek") && <div className={[styles.dateItem, period == "nextWeek" ? styles.selected : ""].join(' ')} onClick={readOnly ? undefined : () => setPeriod("nextWeek")}>Semaine prochaine</div>}
        {(!readOnly || (parseInt(period) >= 0 && parseInt(period) < 12)) && <MonthPicker readOnly={readOnly} selectedMonthIndex={parseInt(period) ?? -1} onMonthSelected={(m) => setPeriod(m.toString())}/>}
        <TimePicker readOnly={readOnly} selectedTime={time} onTimeSelected={(selectedTime) => setTime(selectedTime)}/>
    </div>;

}

export default PeriodPicker;